<template>
  <div class="container my-5 py-4 py-md-10" style="background-color: lightgrey;">
    <div class="container">
      <div class="row gx-3">
        <div class="col-12">
          <h2>Vergelijkbare auto's</h2>
          <div v-if="relatedCars.length === 0">
            <p>Er zijn geen vergelijkbare modellen gevonden.</p>
          </div>
          <div v-if="relatedCars.length > 0">
            <p>Bekijk ook onze andere auto's</p>
            <div class="row crc-reffer-cards mt-4">

              <div class="col-sm-6 col-lg-3 mt-4 mt-sm-0 d-flex flex-column cursor-pointer" v-for="car in relatedCars.slice(0, 4)" v-bind:key="car.id" @click.prevent="viewCar(car)">
                <a :href="'https://'+domain()+'/aanbod/'+getslug(car)" class="card d-flex flex-column text-decoration-none">
                  <div class="card-img-top crc-img-container">
                    <img :src="car.photos[0].thumb" @click.prevent="viewCar(car)">
                  </div>
                  <div class="card-body">
                    <div class="row">
                      <div class="col" @click.prevent="viewCar(car)">
                        <h3 class="card-title d-inline-block">{{ car.title }} </h3>
                      </div>

                    </div>

                    <p class="card-text" v-html="car.mappeddata.type" @click.prevent="viewCar(car)"></p>
                    <div class="card-usps d-flex flex-wrap" @click.prevent="viewCar(car)">
                      <span>{{  translateDict[car.mappeddata.transmission] ?? car.mappeddata.transmission }}</span>
                      <span>{{ car.mappeddata.year }}</span>
                      <span>{{ car.mappeddata.milage }} km</span>
                    </div>
                  </div>
                  <div class="card-footer" @click.prevent="viewCar(car)">
                    <ul class="list-group list-group-flush">
                      <li class="list-group-item d-flex flex-wrap justify-content-between align-items-center"><span>Kenteken:</span>
                        <span v-if="car.mappeddata.plate && isValidPlate(car.mappeddata.plate)">{{ car.mappeddata.plate }}</span>
                        <span v-else>n.t.b.</span>
                      </li>
                      <li class="list-group-item d-flex flex-wrap justify-content-between align-items-center"><span>Prijs aap:</span> <span>{{ formatPrice(car.mappeddata.price) }}</span></li>
                      <li v-if="car.extradata.finance_term" class="list-group-item finance-container d-flex flex-wrap justify-content-between align-items-center"><span>Financieren vanaf:</span> <span>{{ formatPrice(parseInt(car.extradata.finance_term)) }}</span></li>
                    </ul>
                    <a :href="'https://'+domain()+'/aanbod/'+getslug(car)" @click.prevent="viewCar(car)" class="card-link btn mt-3">Bekijk auto</a>
                  </div>
                </a>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";

export default {
  props: ['car', 'cars', 'contact'],
  data() {
    return {
      relatedCars: [],
      translateDict: {
        "j":"Nieuw",
        "n":"Occasion",
        "B":"Benzine",
        "D":"Diesel",
        "B,E":"Benzine & Elektrisch",
        "D,E":"Diesel & Elektrisch",
        "E":"Elektrisch",
        "H":"Handgeschakeld",
        "A":"Automaat",
      },
    }
  },
  mounted()
  {
    let id = this.car.mappeddata.carid;
    this.getRelatedCars(id)
  },
  methods: {
    formatPrice(price) {
      let euroformatter = new Intl.NumberFormat('nl-NL', {
        style: 'currency',
        currency: 'EUR',
      });
      return euroformatter.format(price)
    },
    isValidPlate(plate) {
      const regex = /^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d]{6}$/;
      return regex.test(plate);
    },
    viewCar(car) {
      let type = car.mappeddata.type.replace(/[\W_]+/g,"-")
      let slug = car.mappeddata.slug.replace(/\D/g,"")
      this.$router.push({ name: 'DetailByModel', params: {model: window.slugify(car.mappeddata.brand) + '-' + window.slugify(car.mappeddata.model) + '-' + window.slugify(type + '-') + window.slugify(slug) } })
    },
    domain() {
      return window.location.host;
    },
    getslug(car) {
      return window.getslug(car);
    },

    getRelatedCars(id) {
      axios.get(window.crcBaseApiUrl+'related/'+ id).then( (response)  => {
        this.relatedCars = response.data.filter(x => x.mappeddata.carid != this.car.mappeddata.id)
      });
    }
  },
}
</script>
<style lang="scss" scoped>
.finance-container{
  background-color: #dc182c !important;
  padding: 5px 24px !important;
  margin-top: 25px;
  border-radius: 50px !important;
  color: #fff !important;
  font-weight: 500;
  border: unset !important;
  font-size: 1.1rem;
}
.crc-car-component-container {
  .crc-single-car-hero .col-inner {
    border-radius: 4px;
    background-color: white;
  }

  .crc-imgslider {
    .crc-img-container {
      height: 700px;
    }
  }

  .crc-imgslider-nav {
    .crc-img-container {
      height: 100px;
      width: 14%;
    }
  }

  .crc-buttons {
    margin: 0 -6px;
    display: flex;
    flex-wrap: wrap;

    .btn {
      width: calc(100% - 12px);
      margin: 6px;

      &.half {
        width: calc(50% - 12px);
      }
    }
  }

  .crc-side-imgbg {
    background: linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0) 35%, rgba(0,0,0,.7) 100%);
    background-color: lightgrey;
    border-radius: 4px;
  }

  .crc-reffer-cards {
    .crc-reffer-card-img-head {
      position: relative;

      .crc-img-container {
        height: 200px;

        &.person {
          position: absolute;
          bottom: -20px;
          left: 48px;
          width: 100px;
          height: 100px;
          border-radius: 100px;
        }
      }
    }

    .crc-reffer-card-body {
      background-color: white;

      a.btn {
        width: 100%;
      }
    }
  }
}
</style>
